import '@babel/polyfill'
import 'mutationobserver-shim'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './plugins/bootstrap-vue'
import dynamicTitle from './plugins/dynamic-title'
import App from './App'
import router from './router'

import './assets/scss/main.scss' 

try {
  FONTPLUS.async();
} catch (error) {
  console.log("Cannot load fontplus.");
}

Vue.mixin(dynamicTitle)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  methods: {
    displayImage: function() {
      document.querySelectorAll('.article img').forEach( img => {
        // 画像の要素が見えた時
        if (window.parent.screen.height - 200 > img.getBoundingClientRect().top) {
          img.classList.add("appear")
        } 
      });
      document.querySelectorAll('.article img.appear').forEach( img => {
        // 画像の要素が消えた時
        if (window.parent.screen.height - 200 < img.getBoundingClientRect().top) {
          img.classList.remove("appear")
        } 
      });
    },
    window:onload = function() {
      document.querySelectorAll('.article img').forEach( img => {
        // 画像の要素が見えた時
        if (window.parent.screen.height + 500 > img.getBoundingClientRect().top) {
          img.classList.add("appear")
        } 
      });
    }
  },
  mounted: function() {
    window.onscroll = function (e) {
      e.preventDefault();
      this.displayImage();
    }.bind(this);
  }
})



// WEBPACK FOOTER //
// ./src/main.js